import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Action, DecisionDto, LogDto } from '@coin/importer/dto/util';
import { LogsService } from '../../services/logs/logs.service';
import { ToastService } from '../../services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatHint } from '@angular/material/select';
import { UpperCasePipe, DecimalPipe } from '@angular/common';
import { PercentagePipe } from '../../pipes/percentage/percentage.pipe';
import { FileNamePipe } from '../../pipes/file-name/file-name.pipe';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

type InitialData = {
  log: LogDto;
  action: Action;
};

@Component({
  selector: 'importer-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatInput,
    MatCheckbox,
    FormsModule,
    MatDivider,
    MatFormField,
    MatLabel,
    MatHint,
    V2ButtonComponent,
    UpperCasePipe,
    DecimalPipe,
    PercentagePipe,
    FileNamePipe
  ]
})
export class PopupComponent {
  matDialogRef = inject<MatDialogRef<PopupComponent>>(MatDialogRef);
  data = inject<InitialData>(MAT_DIALOG_DATA);
  private readonly logsService = inject(LogsService);
  private readonly toast = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  actionEnum = Action;
  public action: Action;
  public comment: string;
  public publish: boolean = true;
  public logDetails: LogDto;
  commentForm: UntypedFormGroup;
  isSubmitting = false;

  constructor() {
    const { data } = this;

    this.logDetails = data.log;
    this.action = data.action;
  }

  close() {
    this.matDialogRef.close();
  }

  submit() {
    this.isSubmitting = true;
    const decision: Partial<DecisionDto> = {
      action: this.action,
      comment: this.comment,
      decidedAt: new Date(),
      publish: this.publish
    };
    this.logsService
      .sendDecision(this.logDetails.id, this.data.log.fileType.prefix, decision)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result: LogDto) => {
          if (result) {
            if (result.decision) {
              this.logDetails.decision = result.decision;
            }
            if (result.coinProcessingState) {
              this.logDetails.coinProcessingState = result.coinProcessingState;
            }
            this.toast.success('Your decision was successfully submitted.');
            this.matDialogRef.close(this.logDetails);
          } else {
            this.toast.error('Undefined Error - please try again later.');
            this.isSubmitting = false;
          }
        },
        () => {
          this.isSubmitting = false;
        }
      );
  }
}
